import { createFileRoute } from "@tanstack/react-router";

import { HostedAuth0Redirect } from "@/components/auth/HostedAuth0Redirect";
import { PRODUCT_NAME } from "@/lib/product";

export const Route = createFileRoute("/signup")({
  head: () => ({ meta: [{ title: `Create account · ${PRODUCT_NAME}` }] }),
  component: SignupPage,
});

function SignupPage() {
  return <HostedAuth0Redirect screenHint="signup" />;
}
